import React from "react";
import { Plan } from "../../../@types";
import { useTranslate } from "../../../helpers";
import { SubSectionTable } from "./helper";

export const ContactInformation: React.FunctionComponent<{ plan: Plan }> = ({
  plan,
}) => {
  const t = useTranslate();

  // porting the logic from "old" overview code
  const contactData = [
    {
      label: t("plan_details.overview.contact_information.plan_address"),
      value: (
        <address className="ds-u-font-style--normal">
          {plan.address_1}
          <br />
          {plan.address_2 && (
            <>
              {plan.address_2}
              <br />
            </>
          )}
          {plan.city}, {plan.state} {plan.zipcode}
        </address>
      ),
    },
  ];

  return (
    <div>
      <SubSectionTable
        data={contactData}
        caption={t("plan_details.overview.contact_information")}
      />
    </div>
  );
};
